/* eslint-disable import/no-cycle */
import Utils from '../Utils.js';
import InterfaceActions from './InterfaceActions.js';
import Access from './InterfaceReducer.js';
const {
  getId
} = Utils;
class Messages {
  /**
   * creates Messages
   * @param {string} parentPath the path of the api call for the immediate parent
   */
  constructor(parentPath, id) {
    this.id = getId(id);
    this.parentPath = parentPath;
    this.path = `${parentPath}/${this.id}.message`;
  }
  send(message) {
    return InterfaceActions.sendOutboundDeviceMessage(this.path, message, this.id);
  }

  /**
   * gets the sent outbound messages
   * @param {object} state the current redux state
   * @param {string} queryName identifier of the query
   * @returns {object} the sent outbound messages
   */
  getMessages(state, opts) {
    return Access.getList(state, this.path, opts);
  }
}
function create(parentPath, id) {
  return new Messages(parentPath, id);
}
export default {
  create
};
export { Messages };